export const environment = {
    production: true,
    googleMapsApiKey: 'AIzaSyCzrqbcOh2FFnj5BGvekP3A4bMTsyD3CTQ',
};
